<template>
  <header>
    <section class="parent-link">
      <a href="https://www.complexearth.com">
        <i class="fas fa-chevron-left" />
        {{ $t("back_to_parent") }}
      </a>
    </section>
    <section class="nav-links">
      <router-link class="button" to="/" exact>{{
        $t("routes.home")
      }}</router-link>
      <!-- <router-link class="button" to="/patches">{{
        $t("routes.patches")
      }}</router-link> -->
    </section>
  </header>
</template>

<script>
export default {
  name: "FfgHeader",
};
</script>

<style scoped lang="scss">
@import "../assets/_variables.scss";

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 6rem;

  .parent-link {
    margin: 1rem;

    & .fas {
      margin: 0.5em;
    }

    a {
      color: $foreground;
      text-decoration: none;
    }
  }

  .nav-links {
    display: flex;
    flex-wrap: wrap;

    a {
      margin-left: 1rem;
    }
  }

  z-index: 99;
}

@media screen and (max-width: 1000px) {
  header {
    padding: 0;
    flex-direction: column;
  }
}

@media screen and (max-width: 800px) {
  header {
    .nav-links {
      flex-direction: column;
      text-align: center;

      a {
        margin-left: 0;
        margin-bottom: 0.5rem;
      }
    }
  }
}
</style>
